import { TFunction } from 'i18next';
import { getAutomationBenefits } from './automationBenefits';
import { getWhoIsThisForList } from './whoIsThisForList';

export const getListItemsJsonLd = (t: TFunction) => {
  const automationBenefits = getAutomationBenefits(t);
  const whoIsThisForList = getWhoIsThisForList(t);

  return [
    {
      heading: 'How our automation solves these challenges',
      list: automationBenefits,
    },
    {
      heading: 'Who We Serve',
      list: whoIsThisForList,
    },
  ];
};
